import moment from 'moment'
import React, { useEffect, useState } from 'react'

import styles from './index.module.css'

type Props = {
  date: string
  pxPerMinute: number
}

export const CurrentTimeLine: React.FC<Props> = ({ date, pxPerMinute }) => {
  const [now, setNow] = useState(new Date())

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 60 * 1000)
    return () => clearInterval(timer)
  }, [])

  const isToday = moment(date).isSame(moment(now), 'day')
  if (!isToday) return null

  const minutes = now.getHours() * 60 + now.getMinutes()
  return <div className={styles.bar} style={{ top: minutes * pxPerMinute }} />
}
